import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { FaCar, FaEdit, FaSitemap, FaTrash } from 'react-icons/fa';
import { HiOutlineRectangleGroup } from 'react-icons/hi2';
import { useDispatch } from 'react-redux';
import { vehicleGroupService } from '../../Services/vehicle.group.service';
import { vehicleService } from '../../Services/vehicle.service';
import { maintenancesService } from '../../Services/maintenances.service';
import { useSelected } from '../../contexts/SelectedContext';
import { Filters } from '../../components/Filters';
import { TbStatusChange } from 'react-icons/tb';
import { GridComponent, ColumnsDirective, ColumnDirective, Inject, Page } from '@syncfusion/ej2-react-grids';

export const ShippingItems = () => {
    const mockData = [
        {
            id: 1,
            vehicle: "Carro A",
            item: "Óleo do motor",
            km: 5000,
            days: 30,
            hours: 10,
            status: "Pendente"
        },
        {
            id: 2,
            vehicle: "Carro B",
            item: "Filtro de ar",
            km: 10000,
            days: 60,
            hours: 20,
            status: "Concluído"
        },
        {
            id: 3,
            vehicle: "Carro C",
            item: "Pneu",
            km: 15000,
            days: 90,
            hours: 30,
            status: "Em andamento"
        },
        {
            id: 4,
            vehicle: "Carro D",
            item: "Pastilha de freio",
            km: 20000,
            days: 120,
            hours: 40,
            status: "Pendente"
        },
        {
            id: 5,
            vehicle: "Carro E",
            item: "Correia dentada",
            km: 25000,
            days: 150,
            hours: 50,
            status: "Concluído"
        }
    ];

    const { t } = useTranslation();
    
    const statusOptions = [
        { statusId: 0, statusName: t("MAINTENANCES.PENDINGS.STATUS_SELECT") },
        { statusId: 1, statusName: t("MAINTENANCES.PENDINGS.STATUS_UP_TO_DATE") },
        { statusId: 2, statusName: t("MAINTENANCES.PENDINGS.STATUS_PROVIDE") },
        { statusId: 3, statusName: t("MAINTENANCES.PENDINGS.STATUS_DELAYED") },
        { statusId: 4, statusName: t("MAINTENANCES.PENDINGS.STATUS_COMPLETED") }
    ];

    const dispatch = useDispatch(); /** eslint-disable-next-line */
    dispatch({ type: "title", value: t("MAINTENANCES.SHIPPING.TITLE") });

    // SelectedContext
    const { selectedValues } = useSelected();
    const selectedGroup = selectedValues.veiculos?.[0] || 0;

    // Estados para gerenciar dados
    const [vehicleGroups, setVehicleGroups] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [items, setItems] = useState([]);
    const [filtersLoading, setFiltersLoading] = useState(false);
    const [isLoadingVehicles, setIsLoadingVehicles] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [itens, setItens] = useState(mockData);
    const [newItem, setNewItem] = useState('');
    const [editId, setEditId] = useState(null);
    const [deleteId, setDeleteId] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const fetchVehicleGroups = async () => {
        try {
            setFiltersLoading(true);
            const groups = await vehicleGroupService.fetchGroups();

            if (Array.isArray(groups)) {
                setVehicleGroups(groups);
                if (groups.length === 1) {
                    await fetchVehiclesByGroup(groups[0].vehicleGroupId);
                } else {
                    await fetchVehiclesByGroup(0);
                }
            } else {
                setVehicleGroups([]);
                if (groups?.error) {
                    console.log("Erro ao buscar grupos:", groups.message || groups.friendlyMessage);
                }
                await fetchVehiclesByGroup(0);
            }
        } catch (error) {
            console.log(error);
            setVehicleGroups([]);
        } finally {
            setFiltersLoading(false);
        }
    };

    const fetchVehiclesByGroup = async (groupId) => {
        setIsLoadingVehicles(true);
        try {
            const vehicles = await vehicleService.fetchVehicles(groupId);
            if (Array.isArray(vehicles)) {
                setVehicles(vehicles);
            } else {
                setVehicles([]);
                if (vehicles?.error) {
                    console.log("Erro ao buscar veículos:", vehicles.message || vehicles.friendlyMessage);
                }
            }
        } catch (error) {
            console.log(error);
            setVehicles([]);
        } finally {
            setIsLoadingVehicles(false);
        }
    };

    const listItens = async () => {
        setIsLoadingVehicles(true);
        try {
            const itens = await maintenancesService.fetchItemsMaintenace();
            if (Array.isArray(itens)) {
                setItems(itens);
            } else {
                setItems([]);
                if (itens?.error) {
                    console.log("Erro ao buscar itens:", itens.message || itens.friendlyMessage);
                }
            }
        } catch (error) {
            console.log(error);
            setItems([]);
        } finally {
            setIsLoadingVehicles(false);
        }
    };

    useEffect(() => {
        if (selectedGroup !== null && selectedGroup !== undefined) {
            fetchVehiclesByGroup(selectedGroup);
        }
    }, [selectedGroup]);

    useEffect(() => {
        fetchVehicleGroups();
        listItens();
    }, []);

    const handleEdit = (id) => {
        const itemToEdit = mockData.find((item) => item.id === id);
        if (itemToEdit) {
            setNewItem(itemToEdit.item);
            setEditId(id);
        }
    };

    const handleDelete = () => {
        setItens(itens.filter(item => item.id !== deleteId));
        setShowModal(false);
        setDeleteId(null);
    };

    const actionTemplateEdit = (props) => (
        <button
            className="btn btn-link p-0"
            style={{ color: "var(--text-primary)" }}
            onClick={() => handleEdit(props.id)}
        >
            <FaEdit size={18} />
        </button>
    );

    const actionTemplateDelete = (props) => (
        <button
            className="btn btn-link p-0"
            style={{ color: "var(--text-primary)" }}
            onClick={() => {
                setDeleteId(props.id);
                setShowModal(true);
            }}
        >
            <FaTrash size={18} />
        </button>
    );

    return (
        <div className='ml-4'>
            <p>{t("MAINTENANCES.SHIPPING.DESCRIPTION")}</p>
            <div className="filter-maintenance">
                <Filters
                    id={"veiculos"}
                    isMulti={false}
                    title={t("VIEW_MAP_FILTERS.GROUPS")}
                    hasSubTitle={true}
                    subTitle={t("VIEW_MAP_FILTERS.ALL_GROUPS")}
                    options={vehicleGroups || []}
                    icon={HiOutlineRectangleGroup}
                    hasIcon={true}
                    pageTitle={"maintenances_scheduling"}
                />
                <Filters
                    id={"veiculosGroups"}
                    isMulti={false}
                    title={t("VIEW_MAP_FILTERS.VEHICLES")}
                    hasSubTitle={true}
                    subTitle={t("VIEW_MAP_FILTERS.ALL_VEHICLES")}
                    options={vehicles || []}
                    icon={FaCar}
                    hasIcon={true}
                    pageTitle={"maintenances_shipping"}
                    isLoading={isLoadingVehicles}
                />
                <Filters
                    id={"itens"}
                    isMulti={false}
                    title={t("MAINTENANCES.SHIPPING.ITEMS")}
                    hasSubTitle={true}
                    subTitle={t("MAINTENANCES.SHIPPING.SELECT_ITEM")}
                    options={items || []}
                    icon={FaSitemap}
                    hasIcon={true}
                    pageTitle={"maintenances_shipping"}
                    isLoading={isLoadingVehicles}
                />
                <Filters
                    id={"status"}
                    isMulti={false}
                    title={t("MAINTENANCES.SHIPPING.STATUS")}
                    hasSubTitle={true}
                    subTitle={t("MAINTENANCES.SHIPPING.SELECT_STATUS")}
                    options={statusOptions}
                    icon={TbStatusChange}
                    hasIcon={true}
                    pageTitle={"maintenances_status_filter"}
                    isLoading={false}
                />

                <button className='btn btn-primary'>
                    {t("MAINTENANCES.SHIPPING.SEARCH")}
                </button>
            </div>

            <div className="scheduling-section">
                <h3 className='h3-light'>{t("MAINTENANCES.SHIPPING.VEHICLE_ITEMS")}</h3>

                <div className="container-maintenances">
                    <div className="card">
                        <GridComponent
                            dataSource={itens}
                            allowPaging={true}
                            pageSettings={{ pageSize: 5 }}
                        >
                            <ColumnsDirective>
                                <ColumnDirective field="vehicle" headerText={t("MAINTENANCES.SHIPPING.VEHICLE")} width="150" />
                                <ColumnDirective field="item" headerText={t("MAINTENANCES.SHIPPING.ITEM")} width="200" />
                                <ColumnDirective field="km" headerText={t("MAINTENANCES.SCHEDULING.KM")} width="100" textAlign="Right" />
                                <ColumnDirective field="days" headerText={t("MAINTENANCES.SCHEDULING.DAYS")} width="100" textAlign="Right" />
                                <ColumnDirective field="hours" headerText={t("MAINTENANCES.SHIPPING.HOURS")} width="100" textAlign="Right" />
                                <ColumnDirective field="status" headerText={t("MAINTENANCES.SHIPPING.STATUS")} width="150" />
                                <ColumnDirective
                                    headerText={t("MAINTENANCES.SHIPPING.EDIT")}
                                    width="100"
                                    textAlign="Center"
                                    template={actionTemplateEdit}
                                />
                                <ColumnDirective
                                    headerText={t("MAINTENANCES.SHIPPING.DELETE")}
                                    width="100"
                                    textAlign="Center"
                                    template={actionTemplateDelete}
                                />
                            </ColumnsDirective>
                            <Inject services={[Page]} />
                        </GridComponent>
                    </div>
                </div>
            </div>

            {/* Modal de confirmação de deleção */}
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h4>{t("MAINTENANCES.SHIPPING.CONFIRM_DELETE")}</h4>
                        <p>{t("MAINTENANCES.SHIPPING.CONFIRM_DELETE_MESSAGE")}</p>
                        <div className="modal-actions">
                            <button 
                                className="btn btn-secondary"
                                onClick={() => setShowModal(false)}
                            >
                                {t("MAINTENANCES.SHIPPING.CANCEL")}
                            </button>
                            <button 
                                className="btn btn-danger"
                                onClick={handleDelete}
                            >
                                {t("MAINTENANCES.SHIPPING.DELETE")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

